import { isEmpty } from 'lodash';
import validator from "validator";
import { AdminType } from "@components/admin/AdminList";

export const validateAddAdmin = ({
  name,
  email,
  phone,
  role,
}: AdminType) => {
  let errors: any = {};

  if (isEmpty(name)) {
    errors.name = "Nama wajib diisi";
  };

  if (isEmpty(email)) {
    errors.email = "Email wajib diisi";
  } else {
    if(!validator.isEmail(email)) {
      errors.email = "Email tidak valid"
    }
  };

  if (isEmpty(phone)) {
    errors.phone = "No. HP wajib diisi";
  };

  if (isEmpty(role)) {
    errors.role = "Jabatan wajib dipilih";
  };

  return {
    errors,
    isValid: isEmpty(errors),
  };
};